export const SDK_VERSION = '7.73.0';
